import { createSelector } from 'reselect';
import { getLatestActivity } from 'lib/selectors/getLatestActivity';
import { getOpenActivity } from 'lib/selectors/getOpenActivity';
import { getActivityTypesWithArchived } from 'lib/selectors/getActivityTypes';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';

const getLatestActivityType = createSelector(
  [
    getLatestActivity,
    getOpenActivity,
    getActivityTypesWithArchived,
    getCurrentLaborTicket,
    getPostLaborUpdatesOnNats,
  ],
  (
    latestActivity,
    openActivity,
    activityTypes,
    currentLaborTicket,
    natsFlowEnabled
  ) => {
    // Async flow: use labor ticket as source of truth
    if (natsFlowEnabled) {
      // Always prioritize labor ticket type first
      if (currentLaborTicket?.type) {
        const laborTicketType = currentLaborTicket.type.toLowerCase();
        return {
          name:
            laborTicketType.charAt(0).toUpperCase() + laborTicketType.slice(1),
          activityMode: laborTicketType,
          activityTypeRef: null,
        };
      }

      return null;
    }

    // Standard flow: use actual activity
    if (latestActivity && activityTypes && activityTypes.length) {
      const activityType = activityTypes.find((at) => {
        return at.activityTypeRef === latestActivity.activityTypeRef;
      });
      if (activityType) {
        return activityType;
      }
    }

    return null;
  }
);

export { getLatestActivityType };
